import React, { useContext, useState } from "react";
import { StyleSheet, View, Text } from "react-native";
import ReactAudioPlayer from "react-audio-player";

import Screen from "~/layouts/Screen/";
import SidePanel from "~/components/SidePanel";
import Row from "~/layouts/Row";
import Col from "~/layouts/Col";
import palette from "~/styles/palette";
import { BadgeContext } from "~/contexts/BadgeContext";
import {
  VoicemailsContext,
  VoicemailsProvider,
} from "~/contexts/VoicemailsContext";

import VoicemailList from "~/components/VoicemailsList/index.web";
import VoicemailsHeader from "~/components/Headers/VoicemailsHeader/";

export default function VoicemailsScreen() {
  const { voicemails } = useContext(BadgeContext);
  const [selectedVoicemail, setSelectedVoicemail] = useState(null);

  return (
    <VoicemailsProvider>
      <Screen safeArea>
        <Row style={[styles.container]}>
          <SidePanel />

          <Col>
            <VoicemailsHeader />

            <Row style={[styles.inner]}>
              <Col maxWidth={372} style={[styles.listPanel]}>
                <VoicemailList
                  onVoicemailPress={(item) => setSelectedVoicemail(item)}
                />
              </Col>

              <Col style={[styles.centerPanel]}>
                <View>
                  <Text style={[styles.greeting]}>Hi!</Text>
                </View>

                <Text style={[styles.text]}>
                  {" "}
                  You have{" "}
                  {!!voicemails ? (
                    <Text>
                      {voicemails} new voicemail{voicemails > 1 ? "s" : ""}
                    </Text>
                  ) : (
                    <Text>no unread voicemails</Text>
                  )}
                </Text>
              </Col>

              <Col maxWidth={500} style={[styles.rightPanel]}>
                {selectedVoicemail && (
                  <ReactAudioPlayer src={selectedVoicemail.url} controls />
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Screen>
    </VoicemailsProvider>
  );
}

const styles = StyleSheet.create({
  greeting: {
    textAlign: "center",
    fontSize: 30,
  },
  text: {
    textAlign: "center",
    fontSize: 18,
    color: palette.grey,
  },
  listPanel: {
    borderRightWidth: 1,
    borderRightColor: palette.light_grey,
    height: "100%",
  },
  rightPanel: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  centerPanel: {
    borderRightWidth: 1,
    borderRightColor: palette.light_grey,
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    minWidth: 380,
    height: "100%",
  },
  container: {
    flex: 1,
  },
  inner: {
    minHeight: "calc(100% - 75px)",
  },
});
